import React from 'react';

import "./button3.css"
import Toggle from './toggle';
import { TextHtmlTagType } from '../../misc/tools';

const Button3 = (props: Button3ConfigMain) => {
	return (
		<div className="center-element-horizontal main-content-inner button3-container" aria-label={props.props.buttonText} style={{
			width: props.props.width,
			height: props.props.height,
			backgroundColor: props.props.isSelected ? 'gray' : undefined
		}}>
			<div className={props.props.animImage ? 'button3-container-img-anim' : 'button3-container-img'}>
				<img alt='' style={props.props.imgStyle} className='center-element' src={props.props.imgSrc}/>
			</div>
			<p className='button3-container-text center-element-vertical black-text'>{props.props.buttonText}</p>
			<div className='button3-toggle-container center-element-vertical'>
				<Toggle idFor508={props.props.idFor508} fieldName={props.props.buttonText} defaultIsEnabled={props.props.defaultIsEnabled} onToggled={props.props.onToggled}></Toggle>
			</div>
		</div>
	);

};

export interface Button3ConfigMain {
	props: Button3Config
}

export interface Button3Config {
	idFor508?: string;
	imgSrc: string;
	imgStyle?: any;
	animImage?: boolean;
	buttonText: string;
	defaultIsEnabled: boolean;
	onToggled: (state: boolean) => void;
	width: string;
	height: string;
	isSelected?: boolean;
}

export default Button3;